<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="image-collage" :class="{ 'image-collage--edit-mode': isEditMode }">
      <div
        class="image-container"
        v-if="hasImages"
        :class="{'landscape-portrait': fields.imagesAlignment.value === 'landscapePortrait'}"
      >
        <media-display
          class="image image-portrait"
          aspect-ratio="3/4"
          :sc-image-field="fields.portraitImage"
          :image-desktop-source="fields.portraitImage.value.cloudinary_3x4_fill_crop"
          :fraction="fraction"
        />
        <media-display
          class="image image-landscape"
          aspect-ratio="4/3"
          :sc-image-field="fields.landscapeImage"
          :image-desktop-source="fields.landscapeImage.value.cloudinary_4x3_fill_crop"
          :fraction="fraction"
        />
      </div>
    </div>
  </sc-render>
</template>

<script>

import { Image as ScImage } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'

import get from '~/helpers/get'
import ScRender from '../sc-render'
import MediaDisplay from '~/components/sitecore/media-display'
import fraction from '~/constants/fraction'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'TwoImageGallery',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScImage,
    ScRender,
    MediaDisplay
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    hasImages () {
      return Boolean(
        get(this.fields, ['portraitImage', 'value'])
        && get(this.fields, ['landscapeImage', 'value'])
      )
    },
    fraction () {
      return fraction.twoFr // check styles
    }
  }
}
</script>

<style lang="scss" scoped>
.image-collage {
  display: flex;
  justify-content: center;
  margin: $space-100 0;

  &--edit-mode {
    min-height: 200px;
  }

  .image-container{
    display: flex; // see computed for fraction
    align-items: flex-end;
    justify-content: center;
    padding: 0 $space-080;
  }

  .landscape-portrait {
    .image-portrait{
      order: 1;
      margin-right: 0;
    }

    .image-landscape {
      order: 0;
      margin-right: $space-080;
    }
  }

  img {
    display: block;
    width: 100%;
  }

  .image-portrait {
    margin-right: $space-080;
  }

  .image-landscape {
    margin-bottom: $space-080;
  }

  @include desktop{
    .image-container {
      padding: 0 $space-120;
    }

    .image-portrait {
      margin-right: $space-120;
    }

    .landscape-portrait {
      .image-portrait {
        margin-right: 0;
      }

      .image-landscape{
        margin-right: $space-120;
      }
    }
  }

  @include mobile{
    .image-container {
      display: block;
      width: 100%;
      padding: 0;
    }

    .landscape-portrait {
      display: flex;
      flex-wrap: wrap;

      .image-landscape {
        margin-bottom: $space-090;
        margin-right: $space-110;
      }

      .image-portrait {
        margin-bottom: 0;
      }
    }

    .image:first-of-type {
      margin-right: auto;
    }

    .image-portrait {
      width: 255px;
      margin: 0 auto;
      margin-bottom: $space-090;
    }

    .image-landscape {
      margin-left: $space-050;
      margin-right: $space-110;
      margin-bottom: 0;
    }
  }
}
</style>
